import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('futurum_token');
    if (!token) { setLoading(false); return; }

    try {
      const res = await authAPI.getMe();
      setUser(res.data.user);
    } catch {
      localStorage.removeItem('futurum_token');
      localStorage.removeItem('futurum_user');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { token, user } = res.data;
    localStorage.setItem('futurum_token', token);
    localStorage.setItem('futurum_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    const { token, user } = res.data;
    localStorage.setItem('futurum_token', token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('futurum_token');
    localStorage.removeItem('futurum_user');
    setUser(null);
    window.location.href = '/login';
  };

  const isApproved = user?.status === 'approved';
  const isPending = user?.status === 'pending';

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isApproved, isPending, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export default AuthContext;
